import React from 'react'
import { useTranslation } from 'react-i18next'
import IconSelect, { IconSelectProps } from '@node-space/storybook-components/dist/IconSelect'
import { Box, Text } from '@node-space/ui-components'
import { InputLabelTooltip } from 'components/Text/InputLabelTooltip'

export interface CurrencyInputProps {
  currencyField: IconSelectProps
}

export const CurrencyInput = ({ currencyField }: CurrencyInputProps) => {
  const { t } = useTranslation()

  return (
    <Box>
      <InputLabelTooltip
        forId={currencyField?.name}
        tooltipText={
          <Box flexCol gap={8}>
            <Text variant="body-label" color="inherit">
              {t('businessActivity.currencyTooltip.title')}
            </Text>
            <Text color="inherit">{t('businessActivity.currencyTooltip.settleFunds')}</Text>
            <Text color="inherit">{t('businessActivity.currencyTooltip.yourBusiness')}</Text>
          </Box>
        }
      >
        {currencyField?.label}
      </InputLabelTooltip>
      <IconSelect {...currencyField} iconsUrl={process.env.ICONS_URL} label="" isSearchable />
    </Box>
  )
}
